import { Navigate } from 'react-router-dom';
import { useCommunityContext } from '@/providers/community-context';
import { useUser } from '@/hooks/use-user';
import { resolveCommunityLandingPath } from '@/lib/community-navigation';

/** Unknown community subpaths → kind-appropriate landing. */
export function CommunityPathFallback() {
  const { community } = useCommunityContext();
  const { user } = useUser();
  return <Navigate to={resolveCommunityLandingPath(community, user)} replace />;
}
